export const view03ImageOptions = {
  angle: 'View03',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    BathingPlatform: 1,
    TeakOnBathingPlatform: 1,
    SprayHood: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'BowSprit',
      dependency: 'HullColour'
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'BathingPlatform',
      dependency: 'HullColour'
    },
    {
      option: 'Wheel',
      dependency: 'BathingPlatform'
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43/views/View03.js